// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3T1_p","label":"Radio_label__2XeiF","checkMark":"Radio_checkMark__1qdbw","disabled":"Radio_disabled__2amlY"};